import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { translate } from '@/utils/translator'

import { TravelPeriodDateSummary } from './travelPeriodDateSummary'

export const TravelPeriodSummary = () => {
	const { startDate, endDate, nights } = useCartStore.use.travelPeriod()

	if (!startDate || !endDate) return null

	return (
		<article
			className={cn(
				'flex w-fit flex-col gap-24 border-t border-naturel pt-24 text-naturel',
				'md:rounded-8 md:border-none md:bg-travelPeriod-summary md:p-24 md:pb-32 md:text-travelPeriod-summaryText'
			)}
		>
			<Typography
				style="h3"
				element="h3"
				className="text-textColor md:text-travelPeriod-text"
			>
				{translate('travel-period-summary-title')}
			</Typography>
			<TravelPeriodDateSummary
				startDate={startDate}
				endDate={endDate}
				nights={nights}
				inverted
			/>
		</article>
	)
}
